module.exports = __webpack_public_path__ + "static/img/bannerc.55c6ae1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bannerc.jpg
// module id = bQya
// module chunks = 1